import React from "react";
import IconBlink from "../../../../assets/blink.svg";
import HeroIlustrasi from "../../../../assets/hero-ilustrasi.svg";

export default function Banner() {
  return (
    <div
      style={{
        backgroundColor: "white",
      }}
    >
      <div className="container">
        <div
          style={{
            height: 300,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            justifyContent: 'flex-end',
            position: "relative",
          }}
        >
          {/* <img
            src={HeroIlustrasi}
            alt="image"
            style={{
              height: "288px",
              width: "484px",
              marginBottom: 44,
              objectFit: "cover",
              marginTop: "40px ",
            }}
          /> */}
          <div
          style={{
            height: "180px",
            overflow: "hidden",
          }}
          className="d-none d-md-block"
        >
          <img
            src={HeroIlustrasi}
            alt="heroIlustrasi"
            style={{
              height: "230px",
              objectFit: "cover",
            }}
          />
        </div>
          <div
            style={{
              position: "absolute",
              top: "50%",
              transform: "translateY(-50%)",
              width: "100%",
              textAlign: "left",
            }}
          >
            <h1
              style={{
                textAlign: "left",
              }}
              className="h1-nunito"
            >
              Bersatu dan Bersama Wujudkan {" "}
              <span style={{ color: "#1672BD" }}>
                Layanan 
              </span>
            </h1>
            <h1
              style={{
                textAlign: "left",
                color: "#1672BD" 
              }}
              className="h1-nunito"
            >
              Digital Terpercaya melalui PSrE Indonesia
            </h1>
          </div>
        </div>
      </div>
    </div>
    // <div
    //   style={{
    //     // height: "70px",
    //     backgroundColor: "white",
    //   }}
    // >
    //   <div
    //     className="container"
    //     style={{
    //       padding: "48px 0px",
    //       position: "relative",
    //     }}
    //   >
    //     <div>
    //       <h1
    //         className="h1-nunito"
    //         style={{
    //           maxWidth: "940px",
    //         }}
    //       >
    //         Bersatu, Bersama Wujudkan{" "}
    //         <span style={{ color: "#1672BD" }}>
    //           Layanan Digital Terpercaya dengan TTE
    //         </span>
    //         <img
    //           src={IconBlink}
    //           alt="icon"
    //           style={{ height: "20px", objectFit: "contain", marginBottom: 40 }}
    //         />
    //       </h1>
    //     </div>
    //     <div
    //       style={{
    //         height: "180px",
    //         overflow: "hidden",
    //         position: "absolute",
    //         top: 46,
    //         right: 20,
    //         zIndex: 0,
    //         backgroundImage: `url(${HeroIlustrasi})`
    //       }}
    //     >
    //       <img
    //         src={HeroIlustrasi}
    //         alt="heroIlustrasi"
    //         style={{
    //           height: "230px",
    //           objectFit: "cover",
    //         }}
    //       />
    //     </div>
    //   </div>
    // </div>
  );
}
